/**
 * (Группа 2) Главный дашборд платформы.
 *
 * KPI (активные отели, MRR + %, churn, открытые алерты), карточки алертов
 * (просроченные подписки, очередь модерации поставщиков, сбои фоновых задач),
 * MRR-спарклайн и лента активности команды (по дизайну v4).
 *
 * Данные: TODO(backend) GET /v1/platform/dashboard — сейчас замокано
 * (см. useDashboard.ts).
 */
import { useDashboard } from './useDashboard.js';

function formatRub(kopecks: number): string {
  return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumFractionDigits: 0 })
    .format(kopecks / 100);
}

export function DashboardPage(): JSX.Element {
  const { data, isLoading } = useDashboard();

  return (
    <section className="hsc-page" data-testid="dashboard-page">
      <h1 className="hsc-page__title">Дашборд платформы</h1>

      {isLoading ? (
        <p>Загрузка…</p>
      ) : (
        <>
          <div className="admin-kpi-grid">
            <article className="admin-kpi">
              <span className="admin-kpi__label">Активные отели</span>
              <span className="admin-kpi__value">{data?.kpi.activeTenants ?? 0}</span>
            </article>
            <article className="admin-kpi">
              <span className="admin-kpi__label">MRR</span>
              <span className="admin-kpi__value">{formatRub(data?.kpi.mrrKopecks ?? 0)}</span>
              <span className="admin-kpi__delta">{data?.kpi.mrrChangePct ?? 0}%</span>
            </article>
            <article className="admin-kpi">
              <span className="admin-kpi__label">Churn (30 дней)</span>
              <span className="admin-kpi__value">{data?.kpi.churnRatePct ?? 0}%</span>
            </article>
            <article className="admin-kpi">
              <span className="admin-kpi__label">Открытые алерты</span>
              <span className="admin-kpi__value">{data?.kpi.openAlerts ?? 0}</span>
            </article>
          </div>

          <h2 className="admin-section-title">Алерты</h2>
          {data && data.alerts.length > 0 ? (
            <ul className="admin-alert-list">
              {data.alerts.map((a) => (
                <li key={a.id} className="admin-alert">
                  <strong>{a.title}</strong>
                  <span>{a.detail}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="admin-stub__badge">Алертов нет (или данные замоканы — TODO backend)</p>
          )}

          <h2 className="admin-section-title">MRR за 12 недель</h2>
          <p className="admin-stub__badge">Спарклайн — каркас (TODO backend данных)</p>

          <h2 className="admin-section-title">Активность команды</h2>
          <p className="admin-stub__badge">Лента действий — каркас (TODO backend данных)</p>
        </>
      )}
    </section>
  );
}
